import { z } from "zod";

export const UploadMembershipSignedDocumentSchema = z.object({
  /** S3 key หรือ null เพื่อลบเอกสาร */
  fileId: z.string().min(1).nullable(),
});
export type UploadMembershipSignedDocumentDTO = z.infer<
  typeof UploadMembershipSignedDocumentSchema
>;
